import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';

export const linkStyles = css`
  ${typography({ size: FONT_SIZE.ML })};

  ${media.tablet} {
    ${typography({ size: FONT_SIZE.MLL })};
  }
`;

export const Container = styled.a`
  ${linkStyles}
  margin-bottom: ${OFFSET.XS};
  width: calc(100vw - ${OFFSET.XL});

  ${media.tablet} {
    width: calc(50% - 15px);
  }

  background-color: ${COLORS.WHITE};
  width: 100%;
  text-align: center;
`;

export const ArtworksContainer = styled.a`
  border: 1px solid ${COLORS.BLACK};
  padding: ${OFFSET.M};
  margin-bottom: ${OFFSET.XS};
  max-width: 306px;
  display: block;
  width: calc(100vw - ${OFFSET.XL});

  &:nth-child(2n + 1) {
    margin-right: 30px;
  }

  ${media.tablet} {
    width: calc(50% - 15px);
  }

  &:hover {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
  }
`;

export const GalleryName = styled.div`
  text-transform: uppercase;
`;

export const GalleryRow = styled.div`
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
`;

export const FlexBottomWidth = styled.div`
  margin-bottom: 50px;
  margin-top: 20px;
`;

export const FlexBottomWidthZero = styled.div`
  margin-bottom: 0;
`;
